import React from "react";

class Switch extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={this.props.additionalClasses ? "custom-control custom-switch " + this.props.additionalClasses : "custom-control custom-switch"}>
        <input
          type="checkbox"
          id={this.props.switchId}
          className="custom-control-input"
          name={this.props.name}
          checked={
            this.props.value === true
              ? this.props.value
              : this.props.onText === this.props.value
          }
          onChange={
            this.props.customChangeHandlerRequired
              ? this.handleCustomChange
              : this.props.onChange
          }
          disabled={this.props.disabled ? this.props.disabled : false}
        />
        <label className="custom-control-label" htmlFor={this.props.switchId}>
          {this.props.value === true || this.props.onText === this.props.value
            ? I18n.t(this.props.onText)
            : I18n.t(this.props.offText)}
        </label>
      </div>
    );
  }

  handleCustomChange = (e) => {
    if (this.props.customChangeHandlerRequired === "settlePaymentFolio") {
      this.props.onChange(e.target.checked, this.props.folioId);
    } else if (this.props.customChangeHandlerRequired === "channelSwitches") {
      this.props.onChange(
        this.props.rateID,
        this.props.roomTypeID,
        e.target.checked
      );
    }
  };
}

export default Switch;
